import React from 'react';

type Props = {
    icon: JSX.Element;
    label: string;
    value: string;
};

export const Stat: React.FC<Props> = ({ icon, label, value }) => {
    return (
        <div className="stat">
            <div className="stat-icon">{icon}</div>
            <div className="stat-info">
                <h2 className="stat-value">{value}</h2>
                <p className="stat-label">{label}</p>
            </div>
        </div>
    );
};
